module.exports = __webpack_public_path__ + "static/img/icon.30f4dcac.jpg";